module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    staticStyle: {
      "margin": "20px",
      "width": "60%",
      "min-width": "600px"
    },
    attrs: {
      "model": _vm.form,
      "label-width": "200px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "所有数据每天"
    }
  }, [_c('el-time-select', {
    attrs: {
      "picker-options": {
        start: '00:00',
        step: '00:60',
        end: '23:00'
      },
      "placeholder": "请选择时间"
    },
    model: {
      value: (_vm.form.syntime),
      callback: function($$v) {
        _vm.$set(_vm.form, "syntime", $$v)
      },
      expression: "form.syntime"
    }
  }), _vm._v("\r\n        开始同步更新("), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*尽量选择系统闲时，比如:凌晨1点")]), _vm._v(") \r\n    ")], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.save.apply(null, arguments)
      }
    }
  }, [_vm._v("保存")])], 1), _vm._v(" "), _c('el-divider'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "河北九城数据"
    }
  }, [_c('el-time-select', {
    attrs: {
      "picker-options": {
        start: '00:00',
        step: '00:60',
        end: '23:00'
      },
      "placeholder": "请选择时间"
    },
    model: {
      value: (_vm.form.syntime_hebeijiucheng),
      callback: function($$v) {
        _vm.$set(_vm.form, "syntime_hebeijiucheng", $$v)
      },
      expression: "form.syntime_hebeijiucheng"
    }
  }), _vm._v("\r\n        开始同步更新("), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*尽量选择系统闲时，比如:凌晨3点")]), _vm._v(") \r\n    ")], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.save_hebeijiucheng.apply(null, arguments)
      }
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-57a878b4!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/nav3/set_update.vue
// module id = 753
// module chunks = 2